<template>
    <div class="customer-view">
        <v-row>
            <v-col cols="12" md="12" lg="4" xl="4">
                <div class="card border rounded px-4 py-3">
                    <CustomerDetail
                        :organizationId="organizationId" @tab-selected="handleTabSelection"
                    />
                </div>
            </v-col>
            <v-col cols="12" md="12" lg="8" xl="8" >
                <div class="card border-0  px-0 py-0 bg-transparent">
                    <CustomerTabs :userId="userId" :organizationId="organizationId" :activeTab="activeTab" @tab-selected="handleTabSelection"/>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CustomerDetail from './customerDetail.vue';
import CustomerTabs from './customerTabs.vue';

export default {
    name: 'CustomerView',
    components: {
        CustomerDetail,
        CustomerTabs
    },
    data() {
    return {
      activeTab: 'Activity',
      userId: this.$route.params.user,
      organizationId: this.$route.params.org_id || this.$route.params.organization_id
    };
  },
  methods: {
    handleTabSelection(tabName) {
      this.activeTab = tabName;
    },
  },
}
</script>